import { useMemo, useState } from 'react';
import { Table, PagingQuery } from 'tea-component';
import { useIntl } from 'umi';
import type { IStoreRankDetailsCountriesRanks } from '@/pages/intelligence/types/storeRank';

const { sortable } = Table.addons;

export const PAGE_SIZES = [5, 10, 15];

const ranksSorter = (
  a: IStoreRankDetailsCountriesRanks,
  b: IStoreRankDetailsCountriesRanks,
): number => {
  const aRank = a?.ranks?.find((item: any) => item?.rankCode === 'rank');
  const bRank = b?.ranks?.find((item: any) => item?.rankCode === 'rank');
  // @ts-ignore
  const aRankNum = Number.parseInt(aRank?.rankValue, 10);
  // @ts-ignore
  const bRankNum = Number.parseInt(bRank?.rankValue, 10);
  const isARankNaN = Number.isNaN(aRankNum);
  const isBRankNaN = Number.isNaN(bRankNum);
  if (isARankNaN && isBRankNaN) return 0;
  if (isARankNaN) return 1;
  if (isBRankNaN) return 0;
  return aRankNum - bRankNum;
};

export default function useSubTable(tableData: IStoreRankDetailsCountriesRanks[]) {
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const { formatMessage } = useIntl();
  const handlePagingChange = (pagination: PagingQuery) => {
    const pageIndexTmp = pagination?.pageIndex ?? pageIndex;
    const pageSizeTmp = pagination?.pageSize ?? pageSize;
    setPageIndex(pageIndexTmp);
    setPageSize(pageSizeTmp);
  };

  const sortInfoColumns = useMemo<any[]>(
    () => [
      {
        key: 'rank',
        prefer: 'desc',
        sorter: ranksSorter,
      },
    ],
    [],
  );
  const [sortInfo, setSortInfo] = useState<any[]>([
    { by: 'rank', order: 'desc', sorter: ranksSorter },
  ]);
  const handleSortChange = (payload: any[]) => {
    let sortInfoTmp = payload;
    if (!sortInfoTmp?.length) {
      const rankSortInfo = sortInfo?.[0] ?? {};
      sortInfoTmp = [{ ...rankSortInfo, order: rankSortInfo?.order === 'desc' ? 'asc' : 'desc' }];
    }
    setSortInfo(sortInfoTmp);
    setPageIndex(1);
  };

  const sortedTableData = useMemo<IStoreRankDetailsCountriesRanks[]>(() => {
    if (!Array.isArray(tableData)) return [];

    if (Array.isArray(sortInfo) && sortInfo?.length === 1) {
      let sortValueTrue = {
        ...sortInfo[0],
      } as any;
      if (sortValueTrue.by === 'rank') {
        sortValueTrue = {
          ...sortValueTrue,
          order: sortValueTrue?.order === 'desc' ? 'asc' : 'desc',
        };
        return tableData?.sort(sortable.comparer([sortValueTrue]));
      }
    }
    return tableData?.sort(sortable.comparer(sortInfo));
  }, [tableData, sortInfo]);

  return {
    sortedTableData,

    sortableConfig: {
      columns: sortInfoColumns,
      value: sortInfo,
      onChange: handleSortChange,
    },

    pageableConfig: {
      pageIndex,
      pageSize,
      pageSizeOptions: PAGE_SIZES,
      pageSizeVisible: tableData?.length > PAGE_SIZES[0],
      stateText: formatMessage({ id: 'dbi_pagination_total' }, { total: tableData?.length ?? 0 }),
      pageIndexVisible: tableData?.length > PAGE_SIZES[0],
      jumpVisible: tableData?.length > PAGE_SIZES[0],
      endJumpVisible: tableData?.length > PAGE_SIZES[0],
      stateTextVisible: true,
      recordCount: tableData?.length,
      onPagingChange: handlePagingChange,
    },
  };
}
